import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { TYPE_LABELS } from "@/lib/chem";

const ALL = "__all";

const FilterSelect = ({ value, onChange, placeholder, items, testId }) => (
  <Select value={value || ALL} onValueChange={(v) => onChange(v === ALL ? "" : v)}>
    <SelectTrigger className="w-full sm:w-48 h-11" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value={ALL}>{placeholder}</SelectItem>
      {items.map(([v, l]) => <SelectItem key={v} value={String(v)}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const QuestionFilters = ({ filters, setFilters, points, topics }) => {
  const set = (k) => (v) => setFilters((f) => ({ ...f, [k]: v }));
  const active = filters.search || filters.points || filters.topic || filters.type;
  return (
    <div className="flex flex-col sm:flex-row flex-wrap gap-3">
      <div className="relative flex-1 min-w-[220px]">
        <Search className="absolute z-10 left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
        <Input value={filters.search} onChange={(e) => set("search")(e.target.value)} placeholder="Soru veya şıklarda ara…"
          className="pl-9 h-11" data-testid="question-search-input" />
      </div>
      <FilterSelect value={filters.points} onChange={set("points")} placeholder="Tüm puanlar" testId="filter-points"
        items={points.map((p) => [p, `${p} puan`])} />
      <FilterSelect value={filters.topic} onChange={set("topic")} placeholder="Tüm konular" testId="filter-topic"
        items={topics.map((t) => [t, t])} />
      <FilterSelect value={filters.type} onChange={set("type")} placeholder="Tüm tipler" testId="filter-type"
        items={Object.entries(TYPE_LABELS)} />
      {active && (
        <Button variant="ghost" onClick={() => setFilters({ search: "", points: "", topic: "", type: "" })} data-testid="filter-clear-button" className="h-11">
          <X className="h-4 w-4 mr-1" /> Temizle
        </Button>
      )}
    </div>
  );
};
